import axios from 'axios'
import { Message } from "element-ui";

const axiosHttp = function () {
  axios.interceptors.request.use(function (config) {
     let user = JSON.parse(localStorage.getItem('user'))
     const pushToken = JSON.parse(window.localStorage.getItem('pushToken'))

     let removeGeonames = config.url.includes('secure.geonames.org')
     //let removeIbge = config.url.includes('servicodados.ibge.gov.br')

    config.baseURL = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API_V1;
    if (user && !removeGeonames) config.headers.Authorization = `Bearer ${user.token}`;

    if (pushToken && pushToken !== 'null')
       config.headers.pushToken = true

    return config;
  }, function (err) {
    return Promise.reject(err)
  });
};

const axiosHttpRes = function () {
  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {

    if (error.request.status === 401) {
      localStorage.removeItem('user');
      //document.removeChild(document.documentElement);
      window.location.href = "/login";
    }

    if (error.request.status !== 200) {
        const res = JSON.parse(error.request.response)

      if (res.error && res.error.details) {
        res.error.details.map(v => {
          Message.error(v.message);
        })
        return false
      }

      if (res.details) {
        res.details.map(v => {
          Message.error(v.message);
        })
        return false
      }
      Message.error(res.message || "Ops, algo deu errado!");
    }

    /*localStorage.removeItem('user');
    this.$router.go('/login');*/

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });
};


export {axiosHttp, axiosHttpRes};
